import MDEditor from '@uiw/react-md-editor'
import rehypeSanitize from 'rehype-sanitize'

interface MarkdownRendererProps {
  source: string
}

export function MarkdownRenderer({ source }: MarkdownRendererProps) {
  return (
    <MDEditor.Markdown
      source={source}
      rehypePlugins={[[rehypeSanitize]]}
      style={{ backgroundColor: 'transparent' }}
    />
  )
}
